<template>
  <div :class="avatarClass">
    <JdPopover v-if="showTooltip" placement="bottom" effect="light" width="auto">
      <div :class="ns.be('group', 'popper')">
        <slot />
      </div>
      <template #reference>
        <JdAvatar
          v-if="count"
          v-bind="{ ...props }"
          :class="ns.be('group', 'count')"
          >+{{ count }}</JdAvatar
        >
      </template>
    </JdPopover>
    <JdAvatar
      v-else-if="count"
      v-bind="{ ...props }"
      :class="ns.be('group', 'count')"
      >+{{ count }}</JdAvatar
    >
  </div>
</template>
<script lang="ts" setup>
import { computed, inject } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'
import { isString } from '@jdesign-vue/utils'
import JdPopover from '@jdesign-vue/components/popover'
import { avatarProps } from './avatar'
import { avatarGroupContextKey } from './constants'

defineOptions({
  name: 'JdAvatarRetracted',
})

const ns = useNamespace('avatar')

const avatarGroupContext = inject(avatarGroupContextKey, undefined)
const _size = computed(() => avatarGroupContext?.size || props.size)

const props = defineProps({
  ...avatarProps,
  count: {
    type: Number,
    default: 0,
  },
  showTooltip: Boolean,
})

const avatarClass = computed(() => {
  const classList = [ns.be('group', 'retracted')]
  if (isString(_size.value)) classList.push(ns.m(_size.value))
  return classList
})
</script>
